import React, { PropsWithChildren } from 'react';
import { Field, FieldRenderProps, FieldProps } from 'react-final-form';
// FIXME making custom props optional until this is resolved:
// https://github.com/final-form/react-final-form/issues/175
export interface TextInputFieldProps<FieldValue>
  extends FieldRenderProps<FieldValue, HTMLInputElement> {
  linkId?: string;
  text?: string;
  handleSubmit?: () => void;
}

type AutoSaveProps<FieldValue> = PropsWithChildren<
  { handleSubmit: () => void } & FieldProps<
    FieldValue,
    FieldRenderProps<FieldValue>
  >
>;
const isDirty = ({
  dirtySinceLastSubmit,
  dirty,
  submitSucceeded,
  submitFailed,
  submitting,
}: {
  dirtySinceLastSubmit?: boolean;
  dirty?: boolean;
  submitFailed?: boolean;
  submitting?: boolean;
  submitSucceeded?: boolean;
}) => {
  if (submitting) return false;
  if (submitFailed || submitSucceeded) return dirty || dirtySinceLastSubmit;
  return dirty;
};

const AutoSave = <FieldValue extends any>({
  name,
  handleSubmit,
  isEqual,
  children,
}: AutoSaveProps<FieldValue>) => {
  return (
    <Field
      name={name}
      isEqual={isEqual}
      subscription={{
        value: true,
        active: true,
        dirty: true,
        submitFailed: true,
        submitting: true,
        submitSucceeded: true,
        dirtySinceLastSubmit: true,
      }}>
      {({
        meta: {
          active,
          dirtySinceLastSubmit,
          dirty,
          submitFailed,
          submitSucceeded,
          submitting,
        },
      }) => {
        if (
          !active &&
          isDirty({
            dirty,
            dirtySinceLastSubmit,
            submitFailed,
            submitSucceeded,
            submitting,
          })
        ) {
          setTimeout(handleSubmit);
        }
        return children;
      }}
    </Field>
  );
};
export default AutoSave;
